<template>
  <div class="container_box">
    <h2 class="font-size-14 font-weight-bold mb10 ml4">{{ $t('key1002412') }}</h2>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="720"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--平台设置弹窗-->
    <Modal v-model="platformSettingsModal" :title="$t('key1002411')" class-name="commonModalStyles" :transfer="false" :mask-closable="false">
      <div class="flex align-items-center mb10">
        <span>{{ $t('key1002413') }}</span>
        <RadioGroup v-model="placeOfShipmentType">
          <Radio :label="1">{{ $t('key1000392') }}</Radio>
          <Radio :label="0">{{ $t('key1000393') }}</Radio>
        </RadioGroup>
      </div>
      <template #footer>
        <Button @click="platformSettingsModal=false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="platformSettingsBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getCommonParamKeysData, isValueEmpty, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'thirdPartyPlatformList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParam: {
        platformIds: [],
        platformType: "sales",
        ymsProductCategoryId: null
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793'),
          key: 'name',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002409'),
          key: 'placeOfShipmentType',
          align: 'center',
          minWidth: 250,
          renderHeader(h, params) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002409')),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 450,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002410'),
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17
                  },
                  class: 'cursor ml5 themeColor'
                })
              ])
            ]);
          },
          render(h, params) {
            let placeOfShipmentType = isValueEmpty(params.row.placeOfShipmentType) ? 0 : params.row.placeOfShipmentType;
            let text = placeOfShipmentType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 140,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                    show: v.getPermission('platformSettings_update'),
                    clickFn: () => {
                      v.platformId = params.row.platformId;
                      v.placeOfShipmentType = isValueEmpty(params.row.placeOfShipmentType) ? 0 : params.row.placeOfShipmentType;
                      v.platformSettingsModal = true;
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      platformSettingsModal: false,
      placeOfShipmentType: 0,
      platformId: null,
      paramKey: 'platformValidateDeliveryPlace',
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.tableLoading = true;
      v.axios.post(api.post_ymsPlatform_query, v.pageParam).then(response => {
        if (response.data.code === 0) {
          let list = response.data.datas || [];
          if (list.length > 0) {
            const paramKeyList = list.map(item => `${v.paramKey}_${item.platformId}`);
            getCommonParamKeysData(this.userInfo.merchantId, paramKeyList, false).then((data) => {
              list.map((item) => {
                let paramKey = `${this.paramKey}_${item.platformId}`;
                data.map((ele) => {
                  if (ele.paramKey === paramKey) {
                    let placeOfShipmentType = JSON.parse(ele.paramValue)[0].validate;
                    item.placeOfShipmentType = Number(placeOfShipmentType);
                  }
                });
              });
              v.tableData = list;
              v.updateTableDom('selection');
            });
          }
        }
      }).catch(() => {
        v.tableLoading = false;
      });
    },
    // 确定
    platformSettingsBtn() {
      let paramValue = [{platformId: this.platformId, validate: this.placeOfShipmentType}];
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: `${this.paramKey}_${this.platformId}`,
          paramValue: JSON.stringify(paramValue),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
        this.platformSettingsModal = false;
        this.getList();
      });
    },
  }
};
</script>

<style lang="less">
.commonModalStyles /deep/ {
  .ivu-radio-wrapper {
    margin-right: 30px;
  }
}
</style>
